var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_4402_19866)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4402_19866)",
    filter: "url(#filter1_d_4402_19866)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.9088 45.0631C94.2635 42.5687 91.5113 39.034 81.0817 39.034C64.9677 39.034 62.674 41.42 58.3856 37.2994C54.7669 33.8218 52.6426 50.5559 57.4665 55.8703C55.4306 63.3967 57.0591 70.9354 57.0591 70.9354H102.395C102.395 70.9354 106.2 53.3256 94.9088 45.0631Z",
    fill: "#333399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6366 71.7243C61.6366 71.7243 59.6824 68.1445 55.7738 68.1445C51.8645 68.1445 49.0956 85.3302 61.6366 82.4652V71.7243Z",
    fill: "#FFE4D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8164 71.7243C97.8164 71.7243 99.7707 68.1445 103.68 68.1445C107.589 68.1445 110.357 85.3302 97.8164 82.4652V71.7243Z",
    fill: "#FFE4D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.727 48.6953C49.779 48.6953 55.5053 97.8114 79.727 97.8114C103.949 97.8114 109.675 48.6953 79.727 48.6953Z",
    fill: "#FFEFE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.727 46.023C79.727 46.023 59.3567 43.1496 59.3567 69.2859C59.3567 69.2859 61.922 58.4832 67.8054 55.5373C70.5461 54.1651 71.5499 57.6411 79.727 57.6411C87.9034 57.6411 88.9072 54.1651 91.6479 55.5373C97.5321 58.4832 100.097 69.2859 100.097 69.2859C100.097 43.1496 79.727 46.023 79.727 46.023Z",
    fill: "#333399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3671 100.595L91.3015 93.1641C88.2244 95.933 84.396 97.6493 79.9184 97.6889C75.4408 97.7286 71.5826 96.0794 68.4575 93.3654L68.5208 100.536C68.5376 102.392 67.3507 104.045 65.5871 104.623L47.1909 110.657C41.6812 112.464 37.9565 117.607 37.9565 123.405V126.001H121.93V123.4C121.93 117.604 118.207 112.463 112.702 110.654L94.2985 104.607C92.5624 104.037 91.3832 102.423 91.3671 100.595Z",
    fill: "url(#paint0_linear_4402_19866)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2869 120.711C88.7234 120.711 96.7723 114.788 99.9295 106.458L94.2986 104.607C92.5617 104.037 91.3832 102.424 91.3672 100.596L91.3016 93.1641C88.2245 95.9338 84.3961 97.65 79.9185 97.6897C75.4409 97.7286 71.5827 96.0802 68.4576 93.3654L68.5209 100.536C68.5376 102.393 67.3507 104.045 65.5872 104.624L58.7983 106.852C62.0577 114.973 69.9999 120.711 79.2869 120.711Z",
    fill: "#FFE4D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3459 114.13H38.6118C37.1014 114.13 35.8779 112.907 35.8779 111.396V91.9917C35.8779 90.4813 37.1014 89.2578 38.6118 89.2578C40.1213 89.2578 41.3456 90.4813 41.3456 91.9917V108.663H57.3459C58.8562 108.663 60.0797 109.887 60.0797 111.397C60.0797 112.907 58.8562 114.13 57.3459 114.13Z",
    fill: "url(#paint1_linear_4402_19866)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6118 48.9173C37.1014 48.9173 35.8779 47.6938 35.8779 46.1834V28.7338C35.8779 27.2243 37.1014 26 38.6118 26H57.3459C58.8562 26 60.0797 27.2243 60.0797 28.7338C60.0797 30.2434 58.8562 31.4677 57.3459 31.4677H41.3456V46.1834C41.3456 47.6938 40.1221 48.9173 38.6118 48.9173Z",
    fill: "url(#paint2_linear_4402_19866)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.275 114.13H102.54C101.03 114.13 99.8059 112.907 99.8059 111.396C99.8059 109.887 101.03 108.662 102.54 108.662H118.541V91.9917C118.541 90.4813 119.764 89.2578 121.275 89.2578C122.784 89.2578 124.008 90.4813 124.008 91.9917V111.397C124.008 112.907 122.784 114.13 121.275 114.13Z",
    fill: "url(#paint3_linear_4402_19866)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.275 50.2018C119.764 50.2018 118.541 48.9783 118.541 47.468V31.4677H102.54C101.03 31.4677 99.8059 30.2434 99.8059 28.7338C99.8059 27.2243 101.03 26 102.54 26H121.275C122.784 26 124.008 27.2243 124.008 28.7338V47.468C124.008 48.9783 122.784 50.2018 121.275 50.2018Z",
    fill: "url(#paint4_linear_4402_19866)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6118 27.9527H57.3459C58.5114 27.9527 59.5038 28.6827 59.8974 29.7102C60.0134 29.4066 60.0797 29.0786 60.0797 28.7338C60.0797 27.2243 58.8562 26 57.3459 26H38.6118C37.1014 26 35.8779 27.2243 35.8779 28.7338V30.6866C35.8779 29.177 37.1014 27.9527 38.6118 27.9527Z",
    fill: "url(#paint5_linear_4402_19866)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.275 26H102.54C101.03 26 99.8059 27.2243 99.8059 28.7338C99.8059 29.0786 99.8723 29.4066 99.989 29.7102C100.382 28.6827 101.374 27.9527 102.54 27.9527H121.275C122.784 27.9527 124.008 29.177 124.008 30.6866V28.7338C124.008 27.2243 122.784 26 121.275 26Z",
    fill: "url(#paint6_linear_4402_19866)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.528 70.936C101.528 69.74 100.694 68.7415 99.5756 68.486L97.7106 61.1853C98.4871 60.7574 99.0134 59.9313 99.0134 58.9816C99.0134 57.5925 97.8875 56.4667 96.4985 56.4667C95.4466 56.4667 94.5465 57.112 94.1712 58.0289L81.8178 56.8305C81.5676 55.7054 80.5653 54.8633 79.3647 54.8633C78.1633 54.8633 77.1602 55.7069 76.9108 56.8328L64.7573 58.0121C64.3774 57.1044 63.4819 56.4667 62.4361 56.4667C61.0471 56.4667 59.9212 57.5925 59.9212 58.9816C59.9212 59.8664 60.3789 60.6429 61.0699 61.0915L59.195 68.4287C57.8815 68.5127 56.8418 69.6012 56.8418 70.9353C56.8418 72.3159 57.9547 73.4357 59.3323 73.4494L61.2782 79.6357C60.6908 80.0964 60.3117 80.8104 60.3117 81.6143C60.3117 82.9576 61.3644 84.0507 62.6893 84.1224L64.0097 88.3193C63.3728 88.7754 62.9556 89.5207 62.9556 90.3636C62.9556 91.7526 64.0814 92.8785 65.4712 92.8785C66.1517 92.8785 66.768 92.6077 67.2211 92.1683L76.8887 97.2599C76.865 97.3995 76.8498 97.5422 76.8498 97.6886C76.8498 99.0777 77.9757 100.204 79.3647 100.204C80.7537 100.204 81.8796 99.0777 81.8796 97.6886C81.8796 97.5467 81.8651 97.4087 81.843 97.2729L91.7395 92.06C92.1994 92.5619 92.8585 92.8785 93.593 92.8785C94.9821 92.8785 96.108 91.7526 96.108 90.3636C96.108 89.4116 95.5786 88.5824 94.7982 88.156L96.0652 84.127C96.0797 84.127 96.0935 84.1293 96.1072 84.1293C97.497 84.1293 98.6229 83.0034 98.6229 81.6143C98.6229 80.7448 98.182 79.9789 97.5115 79.5273L99.4352 73.4121C100.623 73.2122 101.528 72.1809 101.528 70.936ZM94.3154 79.8515L82.1535 75.1047L96.8585 72.2282C97.1003 72.631 97.452 72.9605 97.8723 73.1748L96.0073 79.1048C95.3459 79.1307 94.7494 79.4099 94.3154 79.8515ZM96.5099 70.7042L81.5593 73.6287C81.2541 73.0825 80.7507 72.6622 80.1466 72.4647L80.1557 59.7642C80.8338 59.5392 81.3838 59.0342 81.6676 58.3858L94.0591 59.5872C94.3055 60.5796 95.1385 61.3386 96.1705 61.4729L98.0012 68.6339C97.1835 68.994 96.5946 69.7758 96.5099 70.7042ZM78.5912 89.5832H67.8603C67.5338 88.5855 66.6025 87.8631 65.4979 87.8509L64.1997 83.7204C64.8564 83.2917 65.2973 82.564 65.3355 81.7303L77.4776 76.5151C77.772 76.8484 78.1511 77.104 78.5836 77.2451L78.5912 89.5832ZM61.8518 70.6279C61.7587 69.8658 61.3255 69.2106 60.7076 68.8162L62.5803 61.4896C63.7016 61.4256 64.6245 60.6292 64.8793 59.5697L77.0611 58.3881C77.3487 59.0434 77.9063 59.5514 78.5935 59.7726L78.5851 72.4639C77.9787 72.6607 77.4753 73.0818 77.1694 73.6279L61.8518 70.6279ZM60.8213 72.978C61.1203 72.7629 61.372 72.4845 61.5528 72.1611L76.7316 75.1344L64.9129 80.2108C64.4613 79.5411 63.6955 79.0994 62.8259 79.0994C62.7992 79.0994 62.774 79.1032 62.7473 79.104L60.8213 72.978ZM78.5928 91.1454L78.5951 95.295C78.2243 95.414 77.8925 95.6161 77.6187 95.8808L68.6292 91.1454H78.5928ZM81.1191 95.8892C80.8499 95.6268 80.5226 95.4254 80.1572 95.3041L80.155 91.1462H90.1254L81.1191 95.8892ZM93.249 87.8753C92.2856 88.0073 91.4969 88.6824 91.2025 89.5832H80.1542L80.1466 77.2436C80.6058 77.0933 81.007 76.8164 81.3075 76.451L93.6213 81.2566C93.6037 81.3741 93.5923 81.4931 93.5923 81.6151C93.5923 82.4321 93.9843 83.1567 94.5885 83.6159L93.249 87.8753Z",
    fill: "url(#paint7_linear_4402_19866)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_4402_19866",
    x: 0,
    y: 0,
    width: 160,
    height: 160,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_4402_19866"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4402_19866"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_4402_19866"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_4402_19866",
    result: "effect2_dropShadow_4402_19866"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_4402_19866",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4402_19866",
    x: 25,
    y: 25,
    width: 110,
    height: 110,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_4402_19866"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4402_19866"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4402_19866",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4402_19866",
    x1: 89.4011,
    y1: 108.155,
    x2: 86.8797,
    y2: 123.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966,
    stopColor: "#FFBF5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4402_19866",
    x1: 122.5,
    y1: 127.251,
    x2: -10.0001,
    y2: 97.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4498,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DBEC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4402_19866",
    x1: 122.5,
    y1: 61.0068,
    x2: -8.86054,
    y2: 28.7276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.294297,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DBEC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4402_19866",
    x1: 141.25,
    y1: 114.95,
    x2: 83.4527,
    y2: 85.9973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DBEC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4402_19866",
    x1: 141.25,
    y1: 51,
    x2: 84.0968,
    y2: 21.5764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DBEC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4402_19866",
    x1: 122.5,
    y1: 33.1589,
    x2: 63.129,
    y2: -20.7027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.294297,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DBEC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4402_19866",
    x1: 186.431,
    y1: 33.1589,
    x2: 140.304,
    y2: -13.6033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.294297,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DBEC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4402_19866",
    x1: 133.362,
    y1: 101.699,
    x2: 27.1991,
    y2: 47.8336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DBEC7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4402_19866"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(30 26)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceScan);
export default __webpack_public_path__ + "static/media/face-scan.bdf361e1864ed842a45d5703df5e547a.svg";
export { ForwardRef as ReactComponent };